import {useEffect,} from 'react';


import {useProductFeatures} from '../hooks/useProductFeatures.ts';
import {FieldProps} from 'formik';
import {FormikGenericCombobox} from "@flexinet/ui-components";
import {ProductFeature} from "../types.ts";
import {TextInputProps} from "@mantine/core";

export const ProductFeaturesAutocomplete = (props: FieldProps & TextInputProps) => {


    const {
        items: records,
        loading,
        fetchRecords
    } = useProductFeatures();


    useEffect(() => {
        fetchRecords();
    }, []);


    return (

        <FormikGenericCombobox
            records={records || []}
            valueFieldName={'id'}
            renderOption={(record: ProductFeature) => record.name}
            getSelectedOption={(record: ProductFeature) => record.name}
            isLoading={loading}
            {...props}
        />

    );

};